import { formatUSDC } from '@/util/currencyHelpers'
import LineItem from './LineItem'

const Amount = ({ amount }: { amount: number }) => {
  return <LineItem property="Amount" value={formatUSDC(amount)} />
}

export default Amount
